import { ServicePayment } from '@wix/bookings-uou-types';

export const isNotOffered = (servicePayment: ServicePayment) => {
  return servicePayment.offeredAs.length === 0;
};

export const isFixedPrice = (servicePayment: ServicePayment) => {
  return servicePayment.paymentDetails.price > 0;
};
